<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.releases') }}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <releases-list v-if="!showDetails" @itemSelected="itemSelected"></releases-list>
        <release-detail v-if="showDetails" :releaseId="releaseSelected.id" @close="closeDetails"></release-detail>
      </v-col>
    </v-row>

    <v-dialog v-model="isReleaseCommentDialogOpen" persistent max-width="500">
      <release-comment :releaseId="releaseSelected.id" @close="closeComments"></release-comment>
    </v-dialog>
  </v-container>
</template>

<script>
import ReleaseComment from '../../components/EDI/releases/ReleaseComment'
import ReleaseDetail from '../../components/EDI/releases/ReleaseDetail'
import ReleasesList from '../../components/EDI/releases/ReleasesList'

export default {
  name: 'ReleasesPage',
  components: { ReleasesList, ReleaseDetail, ReleaseComment },
  data: () => ({
    releaseSelected: {},
    showDetails: false,
    isReleaseCommentDialogOpen: false
  }),
  methods: {
    itemSelected (item, action) {
      switch (action) {
        case 'detail': {
          this.releaseSelected = item
          this.showDetails = true
          break
        }
        case 'comment': {
          this.releaseSelected = item
          this.isReleaseCommentDialogOpen = true
          break
        }
      }
    },
    closeDetails () {
      this.releaseSelected = {}
      this.showDetails = false
    },
    closeComments () {
      this.releaseSelected = {}
      this.isReleaseCommentDialogOpen = false
    }
  },
  destroyed () {
    sessionStorage.removeItem('vendorPortalExtReleasesFilter')
  }
}
</script>

<style>

</style>
